import { useCallback } from "react";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { useIntegrationConnectionFixingMutation } from "@api/integrationConnection.api";
import { ConnectionFix } from "@components/financialConnection/useOAuthConnectionFix";
import { usePayPalAuthorization } from "./usePayPalAuthorization";

export function usePayPalConnectionFix({
    connection,
    onFixed,
}: {
    connection: IntegrationConnection;
    onFixed?: () => void;
}): ConnectionFix {
    const fixConnectionMutation = useIntegrationConnectionFixingMutation(
        connection,
        onFixed,
    );
    const fixConnection = useCallback(
        (authCode: string, sharedId: string) => {
            fixConnectionMutation.mutate({
                customParams: { authCode, sharedId },
            });
        },
        [fixConnectionMutation],
    );
    const { initializeConnection } = usePayPalAuthorization(fixConnection);

    return {
        startFix: initializeConnection,
        isFixing: fixConnectionMutation.isPending,
    };
}
